import { Model as ORMModel, attr, fk } from 'redux-orm'
import { Types } from '@fedsim/actions'

import { simulate } from 'stateMachines/appearances.simulate'
import { generateAppearances } from '@fedsim/helpers'
import { SegmentsMetaCollection } from '@fedsim/constants'

export class Appearance extends ORMModel {
  static get fields() {
    return {
      groupId: attr({ getDefault: () => 0 }),
      manager: attr({ getDefault: () => false }),
      cost: attr({ getDefault: () => 0 }),

      winner: attr({ getDefault: () => false }),
      loser: attr({ getDefault: () => false }),

      entered: attr({ getDefault: () => false }),
      eliminatedBy: attr({ getDefault: () => false }),

      segmentId: fk({
        to: 'Segment',
        as: 'segment',
        relatedName: 'SegmentAppearence'
      }),
      wrestlerId: fk({
        to: 'Wrestler',
        as: 'wrestler',
        relatedName: 'SegmentWrestler'
      })
    }
  }

  static reducer(action, Appearance, session) {
    let item
    switch (action.type) {
      case Types.RESET:
      case Types.RESET_APPEARANCES:
        session?.Appearance?.all()
          ?.toModelArray()
          ?.forEach(item => item?.delete())
        break
      case Types.GENERATE_APPEARANCES:
        action?.payload?.forEach(newItem => {
          session?.Appearance?.upsert(newItem)
        })
        break
      case Types.ADD_APPEARANCE: {
        const { segmentId = '', wrestlerId = '' } = action?.payload
        const existingMember = session?.Appearance?.get({
          segmentId,
          wrestlerId
        })

        if (existingMember) {
          session.Appearance.upsert({
            ...existingMember._fields,
            ...action.payload
          })
        } else {
          session.Appearance.upsert(action.payload)
        }
        break
      }
      case Types.UPDATE_APPEARANCE:
        item = session.Appearance.withId(action.payload.id)
        if (item) {
          item.update(action.payload)
        }
        break
      case Types.UPDATE_MANAGER: {
        const { segmentId, wrestlerId } = action.payload
        const appearance = session.Appearance.get({
          segmentId,
          wrestlerId
        })
        if (appearance && segmentId && wrestlerId) {
          session.Appearance.upsert({
            ...appearance._fields,
            manager: !appearance.manager
          })
        }
      }
        break
      case Types.DELETE_APPEARANCE:
        Appearance?.all()
          ?.filter(
            appearance =>
              appearance.wrestlerId === action.payload.wrestlerId &&
              appearance.segmentId === action.payload.segmentId
          )
          ?.delete()
        break
      case Types.DELETE_WRESTLER:
        Appearance?.all()
          ?.filter(appearance => appearance.wrestlerId === action.payload.id)
          ?.delete()
        break
      case Types.SIMULATE_SEGMENT:
        {
          const segment = item = session?.Segment?.withId(action?.payload?.id);
          const filter = item => item?.segmentId === action?.payload?.id
          const mapper = joins => {
            return {
              ...joins._fields,
              wrestler: joins?.wrestler?._fields
            }
          }
          const segmentMeta = SegmentsMetaCollection.find(meta => meta.type === segment.type)
          const appearances = session?.Appearance?.all()
            ?.toModelArray()
            ?.filter(filter)
            ?.map(mapper)
          const hasWinner = appearances?.some(item => item.winner)

        if (appearances && !hasWinner && segmentMeta?.category === 'Competition') {
            const collection = simulate(appearances)

            collection?.forEach(item => {
              session.Appearance.withId(item.id).update(item)
            })
          }
        }
        break
      case Types.SELECT_SEGMENT_WINNER:
        {
          const { segmentId = '', wrestlerId = '' } = action?.payload
          {
            const filter = item => item.segmentId === segmentId
            const mapper = joins => {
              return {
                ...joins._fields,
                wrestler: joins?.wrestler?._fields
              }
            }
            const appearances = session?.Appearance?.all()
              ?.toModelArray()
              ?.filter(filter)
              ?.map(mapper)

            if (appearances) {
              const winningAppearance = appearances.find(item => item.wrestlerId === wrestlerId)
              const { groupId } = winningAppearance

              appearances.forEach(item => {
                const winner = item.wrestlerId === wrestlerId || item?.groupId === groupId ? true : false

                session?.Appearance?.withId(item.id).update({ ...item, winner, loser: !winner })
              })
            }
          }
        }
        break
      case Types.RANDOMISE_SEGMENT:
        {
          const { segmentId = false, productionId = false } = action.payload
          let collection = session?.Wrestler?.all()?.toRefArray()

          if (segmentId) {
            // delete existing appearances by this segment
            session.Appearance?.all()
              ?.filter(item => item.segmentId === segmentId)
              ?.toModelArray()
              ?.forEach(item => item.delete())
          }

          if (productionId) {
            let production = session?.Production?.all()
              ?.toRefArray()
              ?.find(item => item.id === productionId)

            const show = session?.Show?.all()
              ?.toRefArray()
              ?.find(item => item.id === production?.showId)

            if (show?.minPoints && show?.maxPoints) {
              const filter = item => item.points >= show.minPoints && item.points <= show.maxPoints

              collection = collection.filter(filter)
            }

            if (production?.brandIds) {
              const filter = item => item?.brandIds?.some(id => production.brandIds?.includes(id))

              collection = collection.filter(filter)
            }

            const usedIds = session?.Appearance?.all()
              ?.filter(item => production?.segmentIds?.includes(item.segmentId))
              ?.toModelArray()
              ?.map(item => item.wrestlerId)

            if(usedIds.length) {
              const filter = item => !usedIds.includes(item.id)
              collection = collection.filter(filter)
            }
          }

          // create a new match
          const competitors = generateAppearances({ data: collection })
          // enter the new appearances
          const appearances = competitors.map(item => ({
            ...item,
            segmentId
          }))

          appearances.forEach(appearance => {
            session.Appearance.create(appearance)
          })
        }
        break
    }
  }
}

export default Appearance
